/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { startCase } from 'lodash';
import CheckBox from '../Common/checkbox';
import { workPackageStateCharacter } from '../../utils/string';
import useDropDownOpen from '../../hooks/useDropDownOpen';

const StateFilter = (props) => {
  const {
    checkedOptions,
    filter,
    fieldName,
    type,
    result,
    toggleDropDownMenu,
    changeStatus,
    disabled,
    options,
    onFilterClick,
    rowIndex
  } = props;

  const { open, setOpen } = useDropDownOpen();

  if (type === 'changeStatus' && !!result) {
    const stateToOptionKey = result.state.replace(' ', '_').toUpperCase();

    return (
      <div id="sprintFilter" className="dropdown">
        <button
          type="button"
          id="sprintFilterLabel"
          className={`icon ${result.state.replace(/ /g, '-').toLowerCase()}`}
          disabled={disabled}
          onClick={(e) =>
            toggleDropDownMenu(e, 'stateMenu', {
              options,
              stateToOptionKey,
              changeStatus,
              index: rowIndex,
              field: fieldName
            })
          }
        >
          {workPackageStateCharacter(result)}
        </button>
      </div>
    );
  }

  const handleButtonClick = () => {
    setOpen((prevOpen) => !prevOpen);
    onFilterClick && onFilterClick();
  };

  return (
    <div id="sprintFilter" className="dropdown">
      <button
        type="button"
        id="sprintFilterLabel"
        className="btn btn-link vrs-filter"
        disabled={disabled}
        onClick={handleButtonClick}
      >
        {type === 'rightPanelList' && (
          <span
            className="glyphicon glyphicon-filter"
            style={{
              color: checkedOptions.length > 0 ? '#000000' : '#FFFFFF',
              marginLeft: '10px',
              verticalAlign: 'unset',
              lineHeight: 0
            }}
            aria-hidden="true"
          />
        )}
        {type !== 'rightPanelList' && 'State'}
      </button>
      {open && (
        <ul className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
          <form>
            {Object.keys(options).map((option) => (
              <li key={options[option]} className="options">
                <CheckBox
                  label={options[option]}
                  value={options[option]}
                  checked={
                    checkedOptions.indexOf(startCase(option.toLowerCase())) !==
                    -1
                  }
                  handleCheckboxChange={(event) =>
                    filter(event, startCase(option.toLowerCase()))}
                />
              </li>
            ))}
            <li>
              <button
                type="button"
                className="btn btn-xs btn-primary"
                onClick={(event) => filter(event)}
              >
                All
              </button>
            </li>
          </form>
        </ul>
      )}
    </div>
  );
};
StateFilter.propTypes = {
  checkedOptions: PropTypes.array,
  type: PropTypes.string,
  result: PropTypes.object,
  filter: PropTypes.func,
  toggleDropDownMenu: PropTypes.func
};

StateFilter.defaultProps = {
  checkedOptions: [],
  type: 'filter',
  result: null
};

export default StateFilter;
